import MainAddress from "../";
import { GetSerialProgram } from "../../util/sessionManager";
import axios from 'axios';

export async function Login(data){
    try{
        console.log({
            ...data,
            serial_program:GetSerialProgram(),
            
        })
        const response = await axios.post(
            MainAddress+"Authentication/login.php",
            {
                ...data,
                serial_program:GetSerialProgram(),
                
            }
          )
    
        if(response.data.success && response.data.state){
            return response.data;
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}